<script lang="ts">
    import { Col, Row } from "sveltestrap";
    import Card from "../UiCommenCard.svelte";
    import {Order, OrderMessage} from "../../../utils/Constant/Constant"
</script>
<Col sm="12">
    <Card cardHeaderprops="pb-0" headerTitle={Order} CardBodyprops="grid-showcase">
      <div slot="contentbody">
        <p>{@html OrderMessage}</p>
        <Row>
          <Col >
            <span>First, but unordered</span>
          </Col>
          <Col class="order-12">
            <span>Second, but last</span>
          </Col>
          <Col class="order-1">
            <span>Third, but first</span>
          </Col>
        </Row>
        <Row>
          <Col class="order-last">
            <span>First, but last</span>
          </Col>
          <Col >
            <span>Second, but unordered</span>
          </Col>
          <Col class="order-first">
            <span>Third, but first</span>
          </Col>
        </Row>
      </div>
    </Card>
</Col>